import PropTypes from 'prop-types';

const themeStyles = {
  dark: 'bg-gray-1',
  light: 'bg-white',
};

// TODO: This appears to be redundant and not needed.
//       This whole component could be integrated into the main Card component.
const CardFooter = ({ children, theme, ...rest }) => (
  <div
    className={`${themeStyles[theme]} border-t border-solid border-gray-2 mt-auto p-4 card-last-margin`}
    {...rest}
  >
    {children}
  </div>
);

CardFooter.defaultProps = {
  theme: 'dark',
};

CardFooter.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['dark', 'light']),
};

export default CardFooter;
